import { render, staticRenderFns } from "./AsMainInProgressSubList.vue?vue&type=template&id=2278af25"
import script from "./AsMainInProgressSubList.vue?vue&type=script&lang=js"
export * from "./AsMainInProgressSubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports